export const frontmatter = {
    "draft": false,
    "title": "Base de conocimiento",
    "sidebar_group": "referencia",
    "sidebar_label": "Base de conocimiento",
    "sidebar_order": 10
}

export const toc = []